import React, { FC, Suspense } from 'react'
import { Loading, TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { View } from '../../../components'
import { FeedbackErrorHandler as ErrorHandler } from '../ErrorHandler'
import { FeedbackViewDataLoader } from './FeedbackViewDataLoader'
import { FeedbackDetailView } from './FeedbackDetailView'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import routePath from 'router/routePath'

export const FeedbackView: FC = () => {
  const { t } = useTranslation(['common', 'feedback', 'titles'])
  const { currentContractId } = useCurrentContract()

  const backPath = routePath.contactInfo.replace(
    ':contractId',
    currentContractId
  )

  const backText = t('titles:contactInformation')

  return (
    <TitleController title={t('feedback:headings.feedback')}>
      <View>
        <View.Header>
          <View.HeaderLink to={backPath}>{backText}</View.HeaderLink>
          <View.HeaderTitle>
            {t('feedback:headings.givenFeedback')}
          </View.HeaderTitle>
        </View.Header>
        <View.Sidebar />
        <View.Content>
          <Suspense fallback={<Loading variant="details" />}>
            <ErrorHandler>
              <FeedbackViewDataLoader>
                {({ feedbackNotice, user }) => (
                  <FeedbackDetailView
                    existingNotice={feedbackNotice}
                    user={user}
                  />
                )}
              </FeedbackViewDataLoader>
            </ErrorHandler>
          </Suspense>
        </View.Content>
      </View>
    </TitleController>
  )
}
